import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const CentralRequests = () => {
  const [zones, setZones] = useState([]);
  const [openZone, setOpenZone] = useState(null); // track which accordion is open
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const getRequests = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URI}/api/request/get/central?source=central`,
        { withCredentials: true }
      );
      if (response.data.success) {
        setZones(response.data.data); // array of zones with requests
      }
    } catch (err) {
      console.error(err);
      setMessage("Failed to load requests");
    }
  };

  useEffect(() => {
    getRequests();
  }, []);

  const toggleZone = (zoneId) => {
    setOpenZone(openZone === zoneId ? null : zoneId);
  };

  return (
    <div className="p-4">
      {message ? (
        <div
          className="bg-red-100 border border-red-300 text-red-500 px-4 py-3 mx-0 rounded relative"
          role="alert"
        >
          <span className="block sm:inline">{message}</span>
        </div>
      ) : null}

      {zones && zones.length > 0 ? (
        zones.map((zone) => (
          <div
            key={zone.zoneId}
            className="mb-4 border border-gray-300 rounded-lg shadow-sm"
          >
            {/* Accordion Header */}
            <button
              onClick={() => toggleZone(zone.zoneId)}
              className="w-full flex justify-between items-center px-4 py-3 text-left bg-gray-100 hover:bg-gray-200 rounded-t-lg"
            >
              <span className="text-lg font-semibold text-gray-700">
                {zone.zoneName || "Unknown Zone"}
              </span>
              <svg
                className={`w-5 h-5 transform transition-transform ${
                  openZone === zone.zoneId ? 'rotate-90' : ''
                }`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </button>

            {/* Accordion Content */}
            {openZone === zone.zoneId && (
              <div className="p-4 bg-white border-t border-gray-200">
                {zone.requests && zone.requests.length > 0 ? (
                  zone.requests.map((request) => (
                    <div
                      key={request._id}
                      onClick={() =>
                        navigate('/central/open-request', {
                          state: { openRequest: request },
                        })
                      }
                      className="flex flex-row justify-between items-center bg-white rounded-lg shadow-md mt-3 p-4 border border-gray-200 hover:shadow-lg transition-shadow duration-300 cursor-pointer"
                    >
                      <div className="flex flex-col">
                        <h3 className="text-lg font-bold text-yellow-600">
                          REQ#{request.requestNumber || `${request._id}`.slice(-3)}
                        </h3>
                        <p className="text-gray-500 text-sm">
                          {Array.isArray(request.menu) && request.menu.length > 0
                            ? request.menu.map((m) => m.name).join(', ')
                            : 'No Menu'}
                        </p>
                        <p className="text-gray-400 text-xs">
                          {new Date(request.date).toLocaleDateString()}
                        </p>
                      </div>
                      <div className="flex flex-row items-center">
                        <span
                          className={`text-sm font-semibold mr-2 ${
                            request.status === 'PENDING'
                              ? 'bg-pink-100 text-pink-800'
                              : 'bg-green-100 text-green-800'
                          } px-3 py-1 rounded-full`}
                        >
                          {request.status}
                        </span>
                        <svg
                          className="w-6 h-6 text-gray-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M9 5l7 7-7 7"
                          ></path>
                        </svg>
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="text-gray-500">No requests for this zone.</p>
                )}
              </div>
            )}
          </div>
        ))
      ) : (
        <div>
          <h6>No Requests Found!</h6>
        </div>
      )}
    </div>
  );
};

export default CentralRequests;
